import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, shallowEqual } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Breadcrumbs from '../../shared/breadcrumbs'
import SelectBillingCycle from '../../shared/steps/selectbillingcycle'
import SelectHostingDomain from '../../shared/steps/selecthostingdomain'
import SelectAdditionalOptions from '../../shared/steps/selectadditionaloptions'
import SelectConfigOptions from '../../shared/steps/selectconfigoptions'

import PageSlider from '../../shared/pageslider'
import CloseButton from '../../shared/closebutton'
import Loading from '../../shared/loading'

import {
  getDataFromURL,
  getCurrentStep,
  getCID
} from '../../../utilities/function/urlparams'

import {
  isConfigurationAdded
} from '../../../utilities/function/configuration'

import {
  usePageCallback
} from "../../../utilities/function/page"

import ProductSidebar from '../../shared/sidebar/productsidebar'

let CustomHosting = (props) => {
  const { location } = props
  const params = getDataFromURL(location.search)
  let cid = getCID(params)
  const isAddonSkip = () =>{
    if(params && params.skipaddon){
      return true
    }
    return false
  }
  const { configurations, cartStatus } = useSelector(state => state.app, shallowEqual)
  const {getAdditionalOptionsData,setAddons,setBillingCycle} = usePageCallback(cid)
  const step = getCurrentStep(configurations, cid)
  const getBreadcrumbsData = () => {
    let nextstep = 0;
    const data = [{
      label: 'Billing Cycle',
      itemStep: nextstep,
      configKey: 'billing_cycle_id'
    }]
    nextstep++
    if(isConfigurationAdded(configurations[cid])){
      data.push({
        label: 'Resources',
        itemStep: nextstep,
        configKey: 'config'
      })
      nextstep++
    }
    data.push({
      label: 'Domain Name',
      itemStep: nextstep,
      configKey: 'name'
    })
    nextstep++
    if(getAdditionalOptionsData() && getAdditionalOptionsData().length && !isAddonSkip()){
      data.push({
        label: 'Addons',
        itemStep: nextstep,
        configKey: 'addons'
      })
    }
    return data
  }



  if(cartStatus==='loading'){
    return (
      <div className='of-page'>
        <Loading wrapper={true}/>
      </div>
    )
  }

  //render resources
  const renderResources = () => {
    if(isConfigurationAdded(configurations[cid])){
      return <SelectConfigOptions />
    }
    return (<></>)
  }

  //render addons
  const renderAddons = () => {

    if(getAdditionalOptionsData() && getAdditionalOptionsData().length && !isAddonSkip()){
      return <SelectAdditionalOptions data={getAdditionalOptionsData()} callback={setAddons} cid={cid} />
    }
    return (<></>)
  }

  return (
    <div className='of-hosting of-page'>
      <div className='of-page__wrapper'>
        <PageSlider step={step}>
          <Breadcrumbs data={getBreadcrumbsData()} step={step} cid={cid} />
          <SelectBillingCycle callback={setBillingCycle} cid={cid} />
          {renderResources()}
          <SelectHostingDomain cid={cid}/>
          {renderAddons()}
          <CloseButton />
        </PageSlider>
        <ProductSidebar />
      </div>
    </div>
  )
}

CustomHosting.propTypes = {
  location: PropTypes.any,
  getSelectedProductStatus: PropTypes.any,
  getSelectedProductData: PropTypes.any,
  getSelectedProductError: PropTypes.any,
  configurations: PropTypes.object,
  history: PropTypes.any
}

CustomHosting = withRouter(CustomHosting)

export default CustomHosting
